import React from "react";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {ReportForm} from "../ReportForm";
import {CaseDetailForm} from "../CaseDetailForm";
import {ApplicationSurvey} from "../../../../widgets/ApplicationSurvey";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";

export enum CASE_MODAL_CONTENT {
  LOADING = 'loading',
  CONFIRM_DELETE = 'confirmDelete',
  MESSAGE = 'message',
  REPORT = 'report',
  SURVEY = 'survey',
  PROCESSING = 'processing',
}

export const CaseModalContent = ({
  userToken,
  message,
  messageType,
  selectedCase,
  organizations,
  mode,
  selectedOrganization,
  assigningStatus,
  handleCloseDialog,
  handleReport,
  handleAccept,
  handleReject,
  handleAssign,
  handleDelete,
  handleChangeStatus,
  handleChangeAssigningOrganization,
  handleAssigningStatus,
  handleOnClickReportButton,
  handleOnClickSurveyButton
}) => ({
  [CASE_MODAL_CONTENT.LOADING]: <LoadingDialog label="載入中" />,
  [CASE_MODAL_CONTENT.CONFIRM_DELETE]: (
    <TwoButtonDialog
      type="warning"
      title="確定要刪除此案件嗎？此動作將無法復原"
      leftLabel="不刪除"
      leftOnClick={handleCloseDialog}
      rightLabel="刪除"
      rightOnClick={() => handleDelete(selectedCase)}
      rightIconName="fa-trash"
      rightColor="warning"
    />
  ),
  [CASE_MODAL_CONTENT.MESSAGE]: (
    <TwoButtonDialog
      type={messageType}
      title={message}
      leftLabel="了解"
      leftOnClick={handleCloseDialog}
    />
  ),
  [CASE_MODAL_CONTENT.REPORT]: (
    <ReportForm
      handleSubmit={(data) => handleReport(selectedCase, data)}
    />
  ),
  [CASE_MODAL_CONTENT.SURVEY]: (
    <ApplicationSurvey docId={selectedCase?.id} onCloseDialog={handleCloseDialog} userToken={userToken} />
  ),
  [CASE_MODAL_CONTENT.PROCESSING]: (
    <CaseDetailForm
      caseId={selectedCase?.id}
      userToken={userToken}
      organizations={organizations}
      mode={mode}
      assigningStatus={assigningStatus}
      handleAccept={() => handleAccept(selectedCase)}
      handleReject={() => handleReject(selectedCase)}
      handleAssign={() => handleAssign(selectedCase, selectedOrganization)}
      onClickChangeStatusButton={() => handleAssigningStatus(selectedCase)}
      onClickReportButton={handleOnClickReportButton}
      onClickSurveyButton={handleOnClickSurveyButton}
      onChangeStatus={handleChangeStatus}
      onChangeAssigningOrganization={handleChangeAssigningOrganization}
    />
  )
})
